import styled, { keyframes, css } from 'styled-components'
import { motion } from 'framer-motion'
import media from 'styled-media-query'

import { Container as ButtonContainer } from '../../components/Button/styles'

// Animation for RGB gradient
const rgbAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const transition = {
  duration: 0.6, // Slightly faster transition
  ease: [0.43, 0.13, 0.23, 0.96],
};

const containerVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0, 
    transition: { 
      delay: 0.2, // Add slight delay
      duration: 0.6,
      ease: "easeOut"
    }
  },
};

export const Grid = styled(motion.div)` // Apply motion here
  display: flex;
  min-height: 100vh;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const Col = styled(motion.div)` // Apply motion here
  width: 520px;
  margin: 0 15px;
  position: relative; // Keep relative if needed for other positioning

  ${({ $left }) =>
    $left &&
    css` 
      img {
        max-width: 90px;
      }

      width: 580px;

      h1 {
        margin-top: 65px;
        font-size: 58px;
        line-height: 60px;
        font-weight: 700; // Increased font-weight
        position: relative; 
        z-index: 1;
        color: #fff; // Added white color
      }
    `}
`;

export const Card = styled(motion.div)` // Apply motion here
  background: #fff;
  border-radius: 8px; // Slightly larger radius
  padding: 40px; // Increase padding
  width: 100%;
  max-width: 400px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15); // Slightly stronger shadow
  margin: 0 auto;
  
  a {
    color: var(--primary);
    text-decoration: none;
    display: block;
    margin: 15px 0; // Increase margin
    text-align: center;
    font-size: 14px;
    transition: color 0.3s ease; // Add transition
    
    &:hover {
      text-decoration: underline;
      color: #004999; // Darken link color on hover
    }
  }
`;

export const Flex = styled.div`
  display: flex;
  width: 100%;
  margin-top: 15px;
  justify-content: center;
  align-items: center;
  
  button {
    width: 100%;
    min-height: 42px;
  }
`

export const Divider = styled.div`
  margin: 20px 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.1);
  height: 2px;
  border-radius: 2px;
`

export const Page = styled.div`
  min-height: 100vh;
  background: var(--primary);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden; // Prevent potential overflows from animations

  * {
    border: none; // Keep this? Review if needed.
  }

  ${media.lessThan('medium')`
    ${Grid} {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 20px 0; // Add some padding on mobile
    }

    ${Col} {
      width: 100%;
      padding: 0 20px; // Adjust padding
      margin: 0;
      margin-bottom: 30px;
      
      &:last-child {
        margin-bottom: 0;
      }

      img {
        max-height: 50px; // Slightly larger logo on mobile
        display: block; // Ensure block display for centering
        margin: 0 auto!important;
        margin-bottom: 20px; // Increase space below logo
      }

      h1 {
        font-size: 36px;
        line-height: 1.2;
        font-weight: 600;
        margin-top: 20px;
        text-align: center;
      }
    }

    ${Card} {
      max-width: 100%;
      padding: 30px;

      input {
        padding: 15px; // Keep input padding
      }
    }

    ${Flex} {
      flex-direction: column;
      align-items: stretch;

      p {
        font-size: 12px;
      }

      ${ButtonContainer} {
        margin-bottom: 0;
        width: 100% !important;
      }
    }
  `}
`

export const Links = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  
  a {
    margin: 5px 0;
    color: var(--primary);
  }
`

export const CardLogo = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  
  img {
    height: 60px;
  }
`
